query tipoPastaStatusSelect($where: EnumItemDTOFilterInput) {
    data: tiposPastaStatus(where: $where)  {
        label
        value
    }
}